import { Permission } from '@/api/types.ts';
import { useCompanyInfoQuery } from '@/api/methods/useCompanyInfoQuery';

export const useIsInterviewOnly = () => {
  const { data } = useCompanyInfoQuery();

  return data?.access?.permissions?.includes(Permission.CAN_CANDIDATES);
};
